<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="600px"
                   maxHeight="500px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header />
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <img :src="asset_cdn('assets/missions/locked.svg')"
                             :alt="getTrans('quests-dashboard.missionLocked', 'Mission Locked')"
                             :title="getTrans('quests-dashboard.missionLocked', 'Mission Locked')">
                    </div>
                    <div class="general-modal__title">
                        <Translate translationKey="quests-dashboard.yourEmailIsNotVerified"
                                   fallback="Your Email is Not Verified" />
                    </div>
                    <div class="general-modal__subtitle">
                        <Translate translationKey="quests-dashboard.toContinueCollectingAwesomePrizes"
                                   fallback="To continue collecting awesome prizes & gaining knowledge, you need to verify your email address." />
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton @click.stop="handleClick">
                            <Translate translationKey="quests-dashboard.verifyEmail"
                                       fallback="Verify Email" />
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { getTrans } from '@/js/helpers/getTrans';

    const modalStore = useModalStore();
    const { isMobileOrTablet } = useDeviceSize();

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.FORCE_EMAIL_VERIFICATION, false);
    };

    const handleClick = () => {
        modalStore.toggleModal(ModalEnum.EMAIL_VERIFY, true);
        handleClose();
    };

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;

.general-modal {
    @include modalMixins.modal;

    &__image {
        img {
            width: 70px;
        }
    }
}
</style>
